"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FABHotkey = void 0;
const button_1 = require("./button");
const helper_1 = require("./helper");
class FABHotkey {
    /** Init */
    init() {
        jQuery('.fab-links').each(function () {
            let hotkey = helper_1.FABHelper.getAttribute(jQuery(this).data('id'), 'hotkey');
            if (hotkey) {
                let ID = jQuery(this).attr('id');
                jQuery(document).bind('keydown', (hotkey).toString(), function () {
                    button_1.FABButton.triggerClick(ID);
                });
            }
        });
    }
}
exports.FABHotkey = FABHotkey;
